import { createBlogLink } from '../../utils/links';

const getMenuItemUrl = ({
  contentItem,
  isCategory,
  isPathologie,
}: {
  contentItem: CentreMenuData | BlogCategory | ZoneCorps;
  isCategory: boolean;
  isPathologie: boolean;
}): string => {
  if (isPathologie && 'slug' in contentItem) {
    return `/pathologies?category=${contentItem.slug}`;
  } else if (isCategory) {
    return createBlogLink(contentItem.uri);
  } else {
    return contentItem.uri;
  }
};

export const addMenuItemsFromContentItems = ({
  menuGroup,
  contentItems,
}: {
  menuGroup: MenuItem;
  contentItems: (CentreMenuData | BlogCategory | ZoneCorps)[];
}): MenuItem => {
  const contentMenuItems = contentItems.map((contentItem) => {
    if (!contentItem) return undefined;
    const isCategoryContentItem = (
      unknownContentItem: typeof contentItem
    ): unknownContentItem is BlogCategory => {
      return Boolean((unknownContentItem as BlogCategory).name);
    };
    const isPathologie = menuGroup.title === 'pathologies';
    return {
      childItems: { nodes: [] },
      id: contentItem.id,
      isRestricted: false,
      label: isCategoryContentItem(contentItem)
        ? contentItem.name
        : contentItem.title,
      target: undefined,
      title: '',
      url: getMenuItemUrl({
        contentItem,
        isCategory: isCategoryContentItem(contentItem),
        isPathologie,
      }),
    };
  });
  return {
    ...menuGroup,
    childItems: { nodes: [...menuGroup.childItems.nodes, ...contentMenuItems] },
  };
};
